"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("../../colors");
// eslint-disable-next-line @typescript-eslint/no-unused-vars

// FlowFixMe: This should be ThemeType but for some reason this causes "Internal error: merge job timed out
var Theme = {
  helpIcon: {
    "default": {
      backgroundColor: _colors.FullPalette.GREY_600,
      borderColor: _colors.FullPalette.GREY_600,
      color: _colors.FullPalette.EVERGREEN_700
    },
    focus: {
      backgroundColor: _colors.FullPalette.GREY_600,
      borderColor: _colors.FOCUS_BORDER_COLOR,
      color: _colors.FullPalette.EVERGREEN_700
    },
    hover: {
      backgroundColor: _colors.FullPalette.GREY_700,
      borderColor: _colors.FullPalette.GREY_700,
      color: _colors.FullPalette.EVERGREEN_700
    },
    active: {
      backgroundColor: _colors.FullPalette.GREY_800,
      borderColor: _colors.FOCUS_BORDER_COLOR,
      color: _colors.FullPalette.WHITE
    }
  },
  tooltip: {
    "default": {
      backgroundColor: _colors.FullPalette.GREY_E500,
      boxShadowColor: _colors.FullPalette.EVERGREEN_700 + '21',
      // 0.13 alpha
      color: _colors.FullPalette.EVERGREEN_700,
      padding: '1rem'
    },
    icon: {
      backgroundColor: _colors.FullPalette.EVERGREEN_600,
      boxShadowColor: 'none',
      color: _colors.FullPalette.WHITE,
      padding: '0.25rem 0.75rem'
    }
  }
};
var _default = exports["default"] = Theme;